<gpt-location-switcher
  *ngIf="languageService.currentLocation$ | async as currentLocation"
  [locations]="environment.locations"
  [selectedLocation]="currentLocation"
  (locationChange)="locationChange($event)"
></gpt-location-switcher>
